'use client';

import { HeaderPanelToggles } from './HeaderPanelToggles';
import { HeaderSearchButton } from './HeaderSearchButton';

export function HeaderActions() {
  return (
    <>
      <HeaderSearchButton />
      <HeaderPanelToggles />
    </>
  );
}
